import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { DonationCategory } from "@app/shared/sdk";

@Component({
  selector: "app-donation-category-form",
  templateUrl: "./donation-category-form.component.html",
  styleUrls: ["./donation-category-form.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DonationCategoryFormComponent implements OnInit {
  dialogTitle: string;
  donationCategoryForm: FormGroup;
  action: string;
  donationCategoryData: DonationCategory;

  constructor(
    public dialogRef: MatDialogRef<DonationCategoryFormComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private formBuilder: FormBuilder
  ) {
    this.action = data.action;

    if (this.action === "edit") {
      this.dialogTitle = "Donation Category Info";
      this.donationCategoryData = data.categoryData;
    } else {
      this.dialogTitle = "Donation Category Info";
      this.donationCategoryData = new DonationCategory();
    }

    this.donationCategoryForm = this.createForm();
  }

  ngOnInit() {}

  createForm() {
    return this.formBuilder.group({
      name: [this.donationCategoryData.name],
      image: [this.donationCategoryData.image],
    });
  }
}
